import React from 'react';
import { useFragment, graphql, FragmentType } from '@frontend/gql/social';
import { CardStat, CardStatLabel } from '../../../components/card-stat';

const impressionRateMetricFragment = graphql(`
  fragment ImpressionRateMetric_TotalInsights on TotalInsights {
    impressionRate
  }
`);

type ImpressionRateMetricProps = {
  data: FragmentType<typeof impressionRateMetricFragment> | null | undefined;
};

export const ImpressionRateMetric = ({ data }: ImpressionRateMetricProps) => {
  const totalInsights = useFragment(impressionRateMetricFragment, data);
  const impressionRate = totalInsights?.impressionRate;

  // Format as percentage with 1 decimal place
  const formattedRate = totalInsights?.impressionRate ? `${(impressionRate * 100).toFixed(1)}%` : '-';

  return (
    <div className="flex flex-col items-start">
      <CardStatLabel>Impression Rate</CardStatLabel>
      <CardStat className="text-xl leading-none">{formattedRate}</CardStat>
    </div>
  );
};
